import { Link as RouterLink } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';
import { SvgArrowNarrowRightFill } from '../SvgIcons';


const TypographyStyled = styled(Typography, { shouldForwardProp: (prop) => prop !== 'disableBoxShadow' })(({ theme, disableBoxShadow }) => ({
  ...({
    boxShadow: 'none',
    textDecoration: 'none',
    cursor: 'pointer',
    transition: 'all 0.3s ease-out 0s',
    willChange: 'revert',
    'i': { lineHeight: 0 },
    '&:hover': {
      boxShadow: !disableBoxShadow ? `0 16px 26px 0 ${alpha(theme.palette.primary.main, 0.3)}` : 'none',
      backgroundColor: !disableBoxShadow ? theme.palette.primary.dark : 'transparent',
      'i': {
        'svg': {
          animation: 'toRightFromLeft .3s forwards',
        }
      },
    }
  })
}));

const TypographyRoot = styled(Typography)(
  ({ theme, disableBoxShadow }) => `
    box-shadow: none;
    text-decoration: none;
    cursor: pointer;
    transition: all 0.3s ease-out 0s;
    will-change: revert;
    i { line-height: 0 };
    &:hover{
      box-shadow: ${!disableBoxShadow ? '0 24px 40px 0 rgba(238, 58, 67, 0.4)' : 'none'};
      i{
        svg {
          animation: toRightFromLeft .3s forwards;
        }
      }
    }
  `
);

export default function TypographyLink({
   component = RouterLink,
   primary,
   children,
   variant = 'h6',
   maxWidth= 348,
   minHeight = 40,
   bgColor,
   textColor = '#FFFFFF',
   iconColor = '#FFFFFF',
   borderColor = 'none',
   disableBoxShadow = false,
   to,
   onClick,
   ...other
}) {
  return (
      <TypographyStyled
        variant={variant}
        to={to}
        onClick={onClick}
        component={component}
        display={'inline-flex'}
        alignItems={'center'}
        gap={1}
        maxWidth={maxWidth}
        minHeight={minHeight}
        color={textColor}
        textAlign={'left'}
        pl={3}
        pr={2}
        py={0.75}
        disableBoxShadow={disableBoxShadow}
        sx={{ backgroundColor: theme => bgColor || theme.palette.color.primaryBlue2 }}
        { ...other }
      >
        { primary || children }
        <Box component={'i'}>
          <SvgArrowNarrowRightFill color={iconColor} />
        </Box>
      </TypographyStyled>
      /* <TypographyRoot
        to={to}
        onClick={onClick}
        component={RouterLink}
        display={'inline-flex'}
        alignItems={'center'}
        gap={1}
        maxWidth={maxWidth}
        fontSize={18}
        fontWeight={700}
        color={textColor}
        textAlign={'left'}
        pl={3}
        pr={2}
        py={0.75}
        disableBoxShadow={disableBoxShadow}
        sx={{ backgroundColor: theme => bgColor || theme.palette.error.main }}
      >
        { primary || children }
        <Box component={'i'}>
          <SvgArrowNarrowRightFill color={iconColor} />
        </Box>
    </TypographyRoot> */
  )
}
